import { ctxTachograph } from '@/contexts/TachographCtx';
import { TabValue } from '@/types';
import { useContext } from 'react';
import { TachoGraphDateSelectMobile } from './TachographDateSelectMobile';
import TachographCategorySelector from './TachographCategorySelector';
import TachographVehicleData from './TachographVehicleData';
import { TachoTabs } from './TachographPopup';
import TachographDriverData from './TachographDriverData';

export function TachographMobileBody({
  activeTab,
  setActiveTab,
}: {
  activeTab: TachoTabs;
  setActiveTab: (tab: TachoTabs) => void;
}) {
  const tachographCtx = useContext(ctxTachograph);

  if (!tachographCtx) return;

  function setSelectedDatesWrapper(from: Date, to: Date) {
    tachographCtx?.setSelectedDates({ from, to });
    tachographCtx?.setTab(TabValue.dateSelect);
  }

  {
    /*
    Mivel mindenhol (target valasztas -> datum valasztas -> result) van, es az volt a keres, hogy itt külön előbb legyen 
    a datum valasztas, mert attol fugg milyen adatok jonnek le, ezert itt a TabValue tabjai fel vannak cserelve
    (targetSelect = Datumvalasztas -> dateSelect = Kategoriavalasztas -> result)
  */
  }

  switch (tachographCtx?.tab) {
    case TabValue.targetSelect:
      return <TachoGraphDateSelectMobile setSelectedDates={setSelectedDatesWrapper} />;
    case TabValue.dateSelect:
      return <TachographCategorySelector setActiveTab={setActiveTab} isPhone={true} />;
    case TabValue.result:
      return activeTab === 'TargetTab' ? (
        <TachographVehicleData isListView={true} activeTab={activeTab} />
      ) : (
        <TachographDriverData isListView={true} activeTab={activeTab} />
      );
  }
}
